/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */


import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import Select, { Props as SelectProps, GroupBase, OnChangeValue } from 'react-select';
import { SelectOption } from '../../../types/select';
import { getStandardsOptions } from '../../../constants/standards-frameworks';
import { ExtraFeature, FeatureStability } from '@g17eco/molecules';


type changeFn = (codes: string[] | undefined) => void

interface Props {
  standardCodes: string[] | undefined;
  onChange: changeFn;
  selectProps?: SelectProps<SelectOption, true, GroupBase<SelectOption>>;
}

const options = getStandardsOptions();


export const StandardSelector = ({ standardCodes = [], onChange, selectProps }: Props) => {


  // Ensure order is preserved by going through form data
  const selectStandards = standardCodes.reduce((acc, code) => {
    const standard = options.find(s => s.value === code)
    return standard ? [...acc, standard] : acc;
  }, [] as typeof options)

  return (
    <FormGroup>
      <Label for='prefferedAltCodes'>Preferred Standards <FeatureStability feature={ExtraFeature.PreferredStandards} /></Label>
      <Select
        placeholder={'Standards'}
        isClearable={true}
        options={options}
        isMulti={true}
        noOptionsMessage={() => 'No users available for selection'}
        value={selectStandards ?? null}
        onChange={(selection: OnChangeValue<SelectOption, true>) => {
          if (selection[0]?.value === null) {
            return onChange([]);
          }
          onChange(selection.map((item) => item.value as string));
        }}
        {...selectProps}
      />
    </FormGroup>

  )
}
